import { Image } from 'antd'
import React from 'react'
import { AWS_S3_RESIZED_URL, AWS_S3_URL, FALLBACK_IMG } from '../../constants'
import { Maybe } from '../../types'
import PDF_PLACE from '../../assets/img/PDF-Placeholder.png'
import { s3Image } from '../../helper'

export const S3Image = ({ nom, fullWidth = false }: { nom: Maybe<string> | undefined; fullWidth?: boolean }) => {
  let isImg = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(nom ?? '')
  let isPdf = /\.(pdf)$/i.test(nom ?? '')

  return (
    <Image
      preview={{
        src: isImg ? `${AWS_S3_URL}${nom}` : isPdf ? `${AWS_S3_RESIZED_URL}resized-${nom}.png` : '',
      }}
      style={{ width: fullWidth ? '100%' : 128, cursor: 'pointer', boxShadow: '3px 3px 3px rgba(0,0,0,.2)' }}
      src={isImg ? `${AWS_S3_RESIZED_URL}resized-${nom}` : isPdf ? `${AWS_S3_RESIZED_URL}resized-${nom}.png` : ''}
      fallback={isImg ? FALLBACK_IMG : PDF_PLACE}
      placeholder
    />
  )
}

const Thumbnail = ({ texte, fullWidth = false }: { texte: Maybe<string> | undefined; fullWidth?: boolean }) => {
  return (
    <div style={{ marginRight: '5px', display: 'flex', flexDirection: 'column' }}>
      <S3Image nom={texte} fullWidth={fullWidth} />
      <a href={s3Image(texte ?? '')} target="_blank" rel="noreferrer">
        Ouvrir dans un onglet
      </a>
    </div>
  )
}

export default Thumbnail
